'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidPhonePortrait = function IoAndroidPhonePortrait(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.8 2.5c1.8 0 3.2 1.5 3.2 3.2v28.6c0 1.7-1.4 3.2-3.2 3.2h-16.1c-1.8 0-3.2-1.5-3.2-3.2v-28.6c0-1.7 1.4-3.2 3.2-3.2h16.1z m0.4 28.8v-22.5h-16.9v22.5h16.9z' })
        )
    );
};

exports.default = IoAndroidPhonePortrait;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-phone-portrait.js
// module id = 2127
// module chunks = 0